'use client';

import { Input, IconButton, Tooltip, Text } from '@terra/ui-design-system';
import { Box, HStack } from '@terra/ui-styled-system';
import { Search01Icon, Cancel01Icon } from '@terra/ui-icons';
import { useTranslations } from 'next-intl';

type MemoriesFilterBarProps = {
  searchTerm: string;
  setSearchTerm: (term: string) => void;
  filteredCount?: number;
};

export function MemoriesFilterBar({
  searchTerm,
  setSearchTerm,
  filteredCount,
}: MemoriesFilterBarProps) {
  const t = useTranslations('memories');
  const hasActiveFilters = searchTerm !== '';
  const handleClearFilters = () => {
    setSearchTerm('');
  };

  return (
    <Box
      w="full"
      px="1"
      bg="bg.canvas"
      borderBottomWidth="1px"
      borderColor="border.subtle"
    >
      <HStack gap="1" alignItems="center" flexWrap="nowrap" w="full" h="31px">
        <HStack gap="2" alignItems="center" flexShrink={0}>
          {filteredCount !== undefined && (
            <>
              <Text
                fontSize="xs"
                color="fg.muted"
                whiteSpace="nowrap"
                flexShrink={0}
              >
                {filteredCount} {filteredCount === 1 ? 'memory' : 'memories'}
              </Text>
              <Box h="4" w="1px" bg="border.default" flexShrink={0} />
            </>
          )}
        </HStack>

        <Box flex="1" position="relative" mx="2">
          <Search01Icon
            size={10}
            style={{
              position: 'absolute',
              left: '4px',
              top: '50%',
              transform: 'translateY(-50%)',
              color: 'var(--colors-fg-muted)',
              zIndex: 1,
            }}
          />
          <Input
            size="xs"
            placeholder={t('searchPlaceholder')}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            pl="6"
            h="6"
            w="full"
          />
        </Box>

        <HStack gap="1" alignItems="center" flexShrink={0}>
          <Tooltip title="Clear filters">
            <IconButton
              variant="ghost"
              size="xs"
              onClick={handleClearFilters}
              aria-label="Clear filters"
              disabled={!hasActiveFilters}
            >
              <Cancel01Icon size={12} />
            </IconButton>
          </Tooltip>
        </HStack>
      </HStack>
    </Box>
  );
}
